/* tslint:disable:no-console */
export const logInDev = (message: string) =>
  process.env.NODE_ENV === "development" && console.log(message);

export const infoInDev = (message: string) =>
  process.env.NODE_ENV === "development" && console.info(message);

export const warnInDev = (message: string) =>
  process.env.NODE_ENV === "development" && console.warn(message);
